module.exports = __webpack_public_path__ + "img/3b225362bae1482dfc04c9c351525adc.png";